import React from "react";

const isProbablyUrl = (s) => /^https?:\/\//i.test(s?.trim() || "");
const isNA = (v) => {
  if (v === null || v === undefined) return true;
  if (typeof v !== "string") return false;
  const s = v.trim().toLowerCase();
  return s === "" || s === "n/a" || s === "na" || s === "none" || s === "-";
};

const ContactsCell = ({ v }) => {
  const items = [
    { label: "📍", key: "google_maps_link" },
    { label: "📸", key: "instagram" },
    { label: "📘", key: "facebook" },
    { label: "🎵", key: "tiktok" },
    { label: "𝕏", key: "X" },
    { label: "☎️", key: "telephone_number" },
  ]
    .map(({ label, key }) => {
      const val = (v?.[key] || "").trim?.() || "";
      if (isNA(val)) return null;
      return { label, key, val };
    })
    .filter(Boolean);

  if (!items.length) return <span style={{ opacity: 0.6 }}>—</span>;

  return (
    <div style={{ fontSize: "0.9em", display: "grid", gap: 4 }}>
      {items.map(({ label, key, val }) => (
        <div key={key} style={{ overflowWrap: "anywhere" }}>
          <span style={{ marginRight: 6 }}>{label}</span>
          {isProbablyUrl(val) ? (
            <a href={val} target="_blank" rel="noreferrer">
              {val}
            </a>
          ) : (
            <span>{val}</span>
          )}
        </div>
      ))}
    </div>
  );
};

export default function VendorTable({ vendors, onEdit, onDelete, onUpload }) {
  return (
    <div className="table-responsive vendor-table-card shadow-sm">
      <table className="table table-hover table-sm align-middle mb-0">
        <thead>
          <tr>
            <th style={{ width: "18%" }}>Name</th>
            <th style={{ width: "14%" }}>Owner</th>
            <th style={{ width: "13%" }}>Admin</th>
            <th style={{ width: "13%" }}>Manager</th>
            <th style={{ width: "13%" }}>Employee</th>
            <th style={{ width: "6%" }}>Active</th>
            <th style={{ width: "17%" }}>Contacts / Socials</th>
            <th style={{ width: "6%" }} className="text-end">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {vendors.map((vendor) => (
            <tr key={vendor.vendor_id}>
              <td>
                <div className="fw-semibold">{vendor.name}</div>
                <div className="text-muted small" style={{ maxWidth: 180, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {vendor.address || vendor.vendor_id}
                </div>
              </td>
              <td>{vendor.owner}</td>
              <td>{vendor.admin || <span style={{ opacity: 0.6 }}>—</span>}</td>
              <td>{vendor.manager || <span style={{ opacity: 0.6 }}>—</span>}</td>
              <td>{vendor.employee || <span style={{ opacity: 0.6 }}>—</span>}</td>
              <td>
                {vendor.active === false ? (
                  <span className="badge bg-light text-danger border">Inactive</span>
                ) : (
                  <span className="badge bg-light text-success border">Active</span>
                )}
              </td>
              <td style={{ maxWidth: 320 }}>
                <ContactsCell v={vendor} />
              </td>
              <td className="text-end">
                <div className="btn-group">
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => onEdit(vendor)}
                  >
                    Update
                  </button>
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => onUpload(vendor)}
                  >
                    Logo
                  </button>
                  <button
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => onDelete(vendor.vendor_id)}
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
